<script>
  import Debug from "./lib/components/Debug/Debug.svelte";
  import GameScreen from "./lib/screens/GameScreen.svelte";
  import SelectPlayerBoardScreen from "./lib/screens/SelectPlayerBoardScreen.svelte";
  import { CurrentStateName } from "./lib/stores/gameStore";

  const gameBoardStates = ["actionHeal"];
  // console.log('BEISPIEL');
</script>

<link rel="preconnect" href="https://fonts.googleapis.com" />
<link rel="preconnect" href="https://fonts.gstatic.com" crossorigin />
<link
  href="https://fonts.googleapis.com/css2?family=Bigelow+Rules&display=swap"
  rel="stylesheet"
/>
<link rel="preconnect" href="https://fonts.googleapis.com" />
<link rel="preconnect" href="https://fonts.gstatic.com" crossorigin />
<link
  href="https://fonts.googleapis.com/css2?family=Merriweather:ital,wght@0,300;0,400;0,700;0,900;1,300;1,400;1,700;1,900&display=swap"
  rel="stylesheet"
/>

<!-- <pre>{JSON.stringify(playerCards, null, 2)}</pre> -->

<div class="wrapper">
  <!-- {JSON.stringify(BEISPIEL)} -->
  {#if $CurrentStateName == "characterSelection"}
    <SelectPlayerBoardScreen />
  {:else if $CurrentStateName == "gameSetup"}
    <div>Loading...</div>
  {:else}
    <GameScreen />
  {/if}
  <!-- <Debug /> -->
</div>

<style>
  @import url("https://fonts.googleapis.com/css2?family=Bigelow+Rules&display=swap");

  .wrapper {
    padding: 1rem 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    font-family: "Merriweather", serif;
  }

  :global(.shadow-lg) {
    box-shadow:
      0px 3px 10px 0px rgba(0, 0, 0, 0.6),
      inset 2px 2px 0px 0px rgba(255, 255, 255, 0.2),
      inset -2px -2px 0px 0px rgba(0, 0, 0, 0.2);
  }

  :global(.shadow-md) {
    box-shadow:
      0px 2px 5px 0px rgba(0, 0, 0, 0.6),
      inset 1px 1px 0px 0px rgba(255, 255, 255, 0.2),
      inset -1px -1px 0px 0px rgba(0, 0, 0, 0.2);
  }

  :global(.shadow-sm) {
    box-shadow:
      0px 1px 1px 0px rgba(0, 0, 0, 1),
      inset 1px 1px 0px 0px rgba(255, 255, 255, 0.2),
      inset -1px -1px 0px 0px rgba(0, 0, 0, 0.2);
  }

  :global(.hover) {
    cursor: pointer;
  }
  :global(.hover:hover) {
    filter: brightness(1.2);
  }

  :global(.headline) {
    font-family: "Bigelow Rules", serif;
    font-weight: bold;
    font-size: 2.5rem;
    font-variant: small-caps;
    letter-spacing: 1.5chr;
    margin: -0.5rem 0;
    transform: scale(1, 0.6);
  }

  :global(.dijitTooltip) {
    font-family: "Merriweather", serif;
    font-weight: 500;
  }
  :global(.dijitTooltipContainer) {
    font-family: "Merriweather", serif;
    font-weight: 500;
    padding: 0.6rem 0.8rem !important;
    background: #dacdaa !important;
    border: none !important;
    clip-path: polygon(
      3% 0,
      7% 1%,
      11% 0%,
      16% 2%,
      20% 0,
      23% 2%,
      28% 2%,
      32% 1%,
      35% 1%,
      39% 3%,
      41% 1%,
      45% 0%,
      47% 2%,
      50% 2%,
      53% 0,
      58% 2%,
      60% 2%,
      63% 1%,
      65% 0%,
      67% 2%,
      69% 2%,
      73% 1%,
      76% 1%,
      79% 0,
      82% 1%,
      85% 0,
      87% 1%,
      89% 0,
      92% 1%,
      96% 0,
      98% 3%,
      99% 3%,
      99% 6%,
      100% 11%,
      98% 15%,
      100% 21%,
      99% 28%,
      100% 32%,
      99% 35%,
      99% 40%,
      100% 43%,
      99% 48%,
      100% 53%,
      100% 57%,
      99% 60%,
      100% 64%,
      100% 68%,
      99% 72%,
      100% 75%,
      100% 79%,
      99% 83%,
      100% 86%,
      100% 90%,
      99% 94%,
      99% 98%,
      95% 99%,
      92% 99%,
      89% 100%,
      86% 99%,
      83% 100%,
      77% 99%,
      72% 100%,
      66% 98%,
      62% 100%,
      59% 99%,
      54% 99%,
      49% 100%,
      46% 98%,
      43% 100%,
      40% 98%,
      38% 100%,
      35% 99%,
      31% 100%,
      28% 99%,
      25% 99%,
      22% 100%,
      19% 99%,
      16% 100%,
      13% 99%,
      10% 99%,
      7% 100%,
      4% 99%,
      2% 97%,
      1% 97%,
      0% 94%,
      1% 89%,
      0% 84%,
      1% 81%,
      0 76%,
      0 71%,
      1% 66%,
      0% 64%,
      0% 61%,
      0% 59%,
      1% 54%,
      0% 49%,
      1% 45%,
      0% 40%,
      1% 37%,
      0% 34%,
      1% 29%,
      0% 23%,
      2% 20%,
      1% 17%,
      1% 13%,
      0 10%,
      1% 6%,
      1% 3%
    );
    box-shadow: inset 0px 0px 17px 4px rgba(136, 108, 65, 1) !important;
  }

  :global(.dijitTooltipConnector) {
    filter: brightness(0.5) sepia(1);
  }
  :global(.dijitTooltip) {
    filter: drop-shadow(0px 4px 6px rgba(0, 0, 0, 0.8))
      drop-shadow(0px 0px 1px hsl(43deg 74% 24%));
  }

  :global(.dijitTooltipContainer .imgtext) {
    display: none;
  }

  :global(.btn) {
    box-sizing: content-box;
    font-family: "Bigelow Rules", serif;
    font-size: 2.5rem;
    font-weight: 600;
    cursor: pointer;
    padding: 0.5rem 1rem;
    /* font-variant: small-caps; */
    letter-spacing: 1.5chr;
    transform: scale(1, 0.6);
    width: fit-content;
    border-top-left-radius: 255px 15px !important;
    border-top-right-radius: 15px 225px !important;
    border-bottom-right-radius: 225px 15px !important;
    border-bottom-left-radius: 15px 255px !important;
    border: solid 3px !important;

    &:hover {
      margin: -4px;
      border: solid 7px !important;
    }

    &button:disabled {
      color: #444;
      background: #ddd;
    }
  }
</style>
